var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('div',{staticClass:"info-box-content-container"},[_c('router-link',{class:((this.$route.name) + "-close"),attrs:{"to":"/"}},[_vm._v("X")]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }